import { Loader } from "@googlemaps/js-api-loader"
import jquery from "jquery"
window.$ = window.jQuery = jquery

const loader = new Loader({
    apiKey: googleApiKey,
    version: "weekly",
})
loader.load().then(() => {
    initMap()
})

$(function () {
    filterIndicators()

    //County input change
    $("#country").on("change", countryInputChange)

    //State input change
    $("#state").on("change", listCities)

    //close filter tags
    $(".close-filter").on("click", closeFilterTag)

    //search physicians
    $("#btnsearch").on("click", function () {
        $("#frmsearch").trigger("submit")
    })
    //connect physicians
    $(".connectBtn").on("click", function () {
        var dataUrl = $(this).data("url")
        if (dataUrl != "") {
            $.ajax({
                url: dataUrl,
                type: "POST",
                dataType: "json",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("X-CSRF-Token", CSFR_TOKEN)
                },
                success: function (response) {
                    if (response.url) {
                        window.location.replace(response.url)
                    }
                },
                error: function (response) {},
            })
        }
    })
    // all checkbox select
    $("#selectAll").on("click", function () {
        var x = $("input.disabled:checkbox")
        $("input:checkbox").not(this).not(x).prop("checked", this.checked)

        if (this.checked) {
            var physicianIdsa = $('input[name="physician_ids[]"]:checked')
                .map(function () {
                    return $(this).val()
                })
                .get()
            if ($("#hidden_ids").val()) {
                physicianIdsa.push($("#hidden_ids").val())
            }

            if (physicianIdsa) {
                $("#hidden_ids").val(unique(physicianIdsa))
            }
        } else {
            var numbersString = $("#hidden_ids").val()
            var yourArray = numbersString.split(",")

            $(".checkItem").each(function () {
                var index = yourArray.indexOf($(this).val())
                if (index >= 0) {
                    yourArray.splice(index, 1)
                }
            })
            if (yourArray) {
                $("#hidden_ids").val(unique(yourArray))
            }
        }
        checkBoxChange()
    })

    $(".checkItem").on("click", function () {
        if (this.checked) {
            var yourArray = JSON.parse("[" + $("#hidden_ids").val() + "]")
            yourArray.push($(this).val())
            $("#hidden_ids").val(unique(yourArray))
        } else {
            var numbersString = $("#hidden_ids").val()
            var yourArray = numbersString.split(",")
            var index = yourArray.indexOf($(this).val())

            if (index >= 0) {
                yourArray.splice(index, 1)
            }
            $("#hidden_ids").val(unique(yourArray))
        }
        checkBoxChange()
    })

    //save group
    $("#frm-addgroup").on("submit", async function (e) {
        // handle the submit event
        e.preventDefault()

        var physicianIds = $('input[name="physician_ids[]"]:checked')
            .map(function () {
                return $(this).val()
            })
            .get()

        let formData = $(this).serialize() + "&physicianIds=" + physicianIds

        $.ajax({
            url: createGroupEndpoint,
            type: "POST",
            data: formData,
            dataType: "json",
            beforeSend: function (xhr) {
                $(".errorMsg").html("")
                $("#body-loader").addClass("active")
            },
            success: function (response) {
                $("#body-loader").removeClass("active")
                if (response.success == false) {
                    // console.log(response.errors);
                    $.each(response.errors, function (key, item) {
                        $("#field-" + key).html("<small>" + item[0] + "</small")
                    })
                } else {
                    alert(response.message)
                    window.location.replace(response.url)
                }
            },
            error: function (response) {},
        })
    })

    //Medical School
    const medicalSchool = document.getElementById("medical_school")
    medicalSchool.addEventListener("change", CheckSchool)

    //institution
    const institution = document.getElementById("institution")
    institution.addEventListener("change", Checkinstitution)

    //speciality
    const speciality = document.getElementById("speciality")
    speciality.addEventListener("change", Checkspeciality)

    //pg_speciality
    const pgSpeciality = document.getElementById("pg_speciality")
    pgSpeciality.addEventListener("change", Checkpgspeciality)

    //pg_institution
    const pgIstitution = document.getElementById("pg_institution")
    pgIstitution.addEventListener("change", Checkpginstitution)
})

function countryInputChange() {
    const countries = window.countries

    const selectedCountryProperties = countries.find(
        (country) => country["printable_name"].toUpperCase() == this.value
    )
    const countyIso = selectedCountryProperties["iso"]
    listStates(countyIso)
}
async function listStates(iso) {
    const stateSelectElement = document.getElementById("state")

    console.log(stateSelectElement)
    stateSelectElement.setAttribute("data-country-iso", iso)
    const requestBody = new FormData()
    requestBody.append("country_iso", iso)
    requestBody.append("_token", window.csrf_token)
    const endpoint = "/get-states"
    const options = {
        method: "POST",
        body: requestBody,
    }
    const request = new Request(endpoint, options)
    const response = await fetch(request)
    const states = await response.json()

    stateSelectElement.innerHTML = ""
    const option = document.createElement("option")
    option.value = ""
    option.innerText = "Select state"
    stateSelectElement.appendChild(option)

    states.forEach((state) => {
        const option = document.createElement("option")
        option.value = state["state"]
        option.innerText = state["state"]
        option.setAttribute("data-state-iso", state["state_code"])
        stateSelectElement.appendChild(option)
    })

    // TODO: Uncomment this once a version of `bootstrap-select` comes out that is compatible with Bootstrap 5.
    //$('.selectpicker').selectpicker("refresh");
}
/**
 * @param {Event} event
 */
async function listCities() {
    const element = this
    const elementId = element.id.replace("state", "")
    const citySelector = document.getElementById("city" + elementId)

    const selectedState = element.querySelector("option:checked")
    const stateIso = selectedState.getAttribute("data-state-iso")
    const countryIso = element.getAttribute("data-country-iso")

    const requestBody = new FormData()
    requestBody.append("state_code", stateIso)
    requestBody.append("country_iso", countryIso)
    requestBody.append("_token", window.csrf_token)

    const endpoint = "/get-cities"
    const options = {
        method: "POST",
        body: requestBody,
    }
    const request = new Request(endpoint, options)
    const response = await fetch(request)
    const cities = await response.json()

    citySelector.innerHTML = ""
    const option = document.createElement("option")
    option.value = ""
    option.innerText = "Select city"
    citySelector.appendChild(option)

    cities.forEach((city) => {
        const option = document.createElement("option")
        option.value = city["city"]
        option.innerText = city["city"]
        citySelector.appendChild(option)
    })

    // TODO: Uncomment this once a version of `bootstrap-select` comes out that is compatible with Bootstrap 5.
    //$('.selectpicker').selectpicker("refresh");
}
function unique(array) {
    var unique_arr = []
    array.forEach(function (i, e) {
        if (unique_arr.indexOf(i) === -1) unique_arr.push(i)
    })
    return unique_arr
}

$(function () {
    if ($("#hidden_ids").val()) {
        $("#btnCreateGroup").removeClass("disabled")
    } else {
        $("#btnCreateGroup").addClass("disabled")
    }
})

function closeFilterTag() {
    const filterName = $(this).data("filter-name")
    const field = document.getElementById(filterName)
    field.value = ""
    $("#frmsearch").trigger("submit")
}

function filterIndicators() {
    const filterIndicatorBootstrapClasses =
        "search-filter text-white bg-info border border-primary p-2 mx-1 rounded-pill"
    const closeFilterIndicatorButtonClasses = "btn-close close-filter"

    const allFilters = $(".search-field")
    jQuery.map(allFilters, (filter) => {
        if (filter.value) {
            const filterIndicator = document.createElement("div")
            filterIndicator.setAttribute(
                "class",
                filterIndicatorBootstrapClasses
            )
            filterIndicator.setAttribute("data-filter-name", filter.id)
            filterIndicator.innerText = filter.value

            const closeBtn = document.createElement("button")
            closeBtn.setAttribute("data-filter-name", filter.id)
            closeBtn.setAttribute("class", closeFilterIndicatorButtonClasses)

            filterIndicator.append(closeBtn)
            const filterIndicatorsSection =
                document.getElementById("active-filters")
            filterIndicatorsSection.append(filterIndicator)
        }
    })
}

function checkBoxChange() {
    var atLeastOneIsChecked =
        $('input[name="physician_ids[]"]:checked').length > 0

    //if(atLeastOneIsChecked){
    if ($("#hidden_ids").val()) {
        $("#btnCreateGroup").removeClass("disabled")
    } else {
        $("#btnCreateGroup").addClass("disabled")
    }
}

function CheckSchool() {
    let val = this.value
    var element = document.getElementById("other_school_div")
    if (val == "other_school_option") element.style.display = "block"
    else element.style.display = "none"
}

function Checkinstitution() {
    let val = this.value
    var element = document.getElementById("other_institution_div")
    if (val == "other_institution_option") element.style.display = "block"
    else element.style.display = "none"
}

function Checkspeciality() {
    let val = this.value
    var element = document.getElementById("other_speciality_div")
    if (val == "other_speciality_option") element.style.display = "block"
    else element.style.display = "none"
}

function Checkpgspeciality() {
    let val = this.value
    var element = document.getElementById("other_pg_speciality_div")
    if (val == "other_pg_speciality_option") element.style.display = "block"
    else element.style.display = "none"
}

function Checkpginstitution() {
    let val = this.value
    var element = document.getElementById("other_pg_institution_div")
    if (val == "other_pg_institution_option") element.style.display = "block"
    else element.style.display = "none"
}

$("body").on("delegate", ".batch_class", "keydown", function (e) {
    var arr = []
    var kk = e.which
    if (kk > 95 && kk < 106) {
        return true
    } else if (kk > 47 && kk < 58) {
        return true
    } else if (kk == 8 || kk == 46) {
        return true
    } else {
        return false
    }
})
$(function () {
    $("#modalconnectBtn").on("click", function () {
        var dataUrl = $(this).data("url")
        var request_message = $(".request_message").val()
        if (
            request_message != "" &&
            request_message != null &&
            request_message.trim() !== ""
        ) {
            $(".error_request_message").text("")
            if (dataUrl != "") {
                $.ajax({
                    url: dataUrl,
                    type: "POST",
                    dataType: "json",
                    data: {
                        _token: CSFR_TOKEN,
                        request_message: request_message,
                    },
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader("X-CSRF-Token", CSFR_TOKEN)
                    },
                    success: function (response) {
                        if (response.url) {
                            window.location.replace(response.url)
                        }
                    },
                    error: function (response) {},
                })
            }
        } else {
            $(".error_request_message").text("Please enter request message")
        }
    })

    $("#connectBtn").on("click", function () {
        var dataUrl = $(this).data("url")
        if (dataUrl != "") {
            $.ajax({
                url: dataUrl,
                type: "POST",
                dataType: "json",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("X-CSRF-Token", CSFR_TOKEN)
                },
                success: function (response) {
                    if (response.url) {
                        window.location.replace(response.url)
                    }
                },
                error: function (response) {},
            })
        }
    })

    $(document).on("click", ".modalconnect", function () {
        var dataurl = $(this).data("url")
        $("#modalconnectBtn").data("url", dataurl)
        $("#connectModal").modal("show")
    })

    $(document).on("click", "#btnCreateGroup", function () {
        $("#newGroup").modal("show")
    })
})

// The following example creates complex markers to indicate beaches near
// Sydney, NSW, Australia. Note that the anchor is set to (0,32) to correspond
// to the base of the flagpole.

function initMap() {
    let mapOptions = { zoom: 10 }
    if (latitude && longitude) {
        mapOptions.center = {
            lat: Number(latitude),
            lng: Number(longitude),
        }
    }

    var map = new google.maps.Map(document.getElementById("map"), mapOptions)
    setMarkers(map)
}

function setMarkers(map) {
    // Data for the markers consisting of a name, a LatLng and a zIndex for the
    // order in which these markers should display on top of each other.
    let beaches = []
    if (users) {
        beaches = users.map((user) => [
            `${user["first_name"]} ${user["last_name"]} `,
            Number(user["latitude"]),
            Number(user["longitude"]),
            Number(user["id"]),
            `${window.origin}/${profileSearch}/${user["user_id"]}`,
        ])
    }

    // Adds markers to the map.

    // Marker sizes are expressed as a Size of X,Y where the origin of the image
    // (0,0) is located in the top left of the image.

    // Origins, anchor positions and coordinates of the marker increase in the X
    // direction to the right and in the Y direction down.

    var image = {
        url: markerURL,
        // This marker is 20 pixels wide by 32 pixels high.
        size: new google.maps.Size(35, 59),
        // The origin for this image is (0, 0).
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at (0, 32).
        anchor: new google.maps.Point(0, 59),
    }
    // Shapes define the clickable region of the icon. The type defines an HTML
    // <area> element 'poly' which traces out a polygon as a series of X,Y points.
    // The final coordinate closes the poly by connecting to the first coordinate.
    var shape = {
        coords: [1, 1, 1, 70, 30, 70, 30, 1],
        type: "poly",
    }

    var bounds = new google.maps.LatLngBounds()
    var infowindow = new google.maps.InfoWindow()
    for (var i = 0; i < beaches.length; i++) {
        var beach = beaches[i]
        var marker = new google.maps.Marker({
            position: {
                lat: beach[1],
                lng: beach[2],
            },
            map: map,
            icon: image,
            shape: shape,
            title: beach[0],
            zIndex: beach[3],
            url: beach[4],
        })

        bounds.extend(marker.position)
        google.maps.event.addListener(marker, "click", function () {
            //infowindow.setContent('<h3>' +this.title+ '</h3>');
            if (userId) {
                infowindow.setContent(
                    '<h3><a target="_blank" href=' +
                        this.url +
                        ">" +
                        this.title +
                        "</a></h3>"
                )
            } else {
                infowindow.setContent(
                    "<h3><a href=" + this.url + ">" + this.title + "</a></h3>"
                )
            }
            infowindow.open(map, this)
        })
        map.fitBounds(bounds)
    }
}
